import { connect } from 'react-redux';
import UserAdminListComponent from 'src/components/views/UserAdmin/UserAdminListPage';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isDomestic,  isAgent } }: IStoreState) => ({
  isDomestic,
  isAgent,
});

export default connect(mapStateToProps)(UserAdminListComponent);



// WEBPACK FOOTER //
// ./src/containers/UserAdminList.ts